import {
    Configuration,
    PublicClientApplication,
    IPublicClientApplication,
    EventType,
    AccountInfo
} from '@azure/msal-browser';
import { Dictionary } from '@modules/shared/models';
import { redirectUri } from '@config/config';

export const msal = {
    config: {} as Configuration,
    instance: {} as IPublicClientApplication,
    scopes: [] as string[]
};

export const initializeMsal = async (msalConfig: Dictionary<string>) => {
    const config: Configuration = {
        auth: {
            authority: msalConfig.REACT_APP_ADAL_INSTANCE + msalConfig.REACT_APP_TENANT,
            clientId: msalConfig.REACT_APP_TCMS_CLIENT_ID,
            redirectUri: redirectUri,
            navigateToLoginRequestUrl: false, // Set to false to prevent redirecting to the login page after sign-in
        },
        cache: {
            cacheLocation: 'localStorage'
        }
        // Uncomment the following lines to enable logging
        // system: {
        //     loggerOptions: {
        //         loggerCallback: (level, message, containsPii) => {
        //             if (containsPii) {
        //                 return;
        //             }
        //             switch (level) {
        //                 case LogLevel.Error:
        //                     console.error(message);
        //                     AppInsights.trackException({ exception: new Error(message) });
        //                     break;
        //                 case LogLevel.Warning:
        //                     console.warn(message);
        //                     AppInsights.trackEvent({ name: 'MSAL Warning', properties: { message } });
        //                     break;
        //                 case LogLevel.Info:
        //                     console.info(message);
        //                     AppInsights.trackEvent({ name: 'MSAL Info', properties: { message } });
        //                     break;
        //                 case LogLevel.Verbose:
        //                     console.debug(message);
        //                     AppInsights.trackTrace({ message });
        //                     break;
        //             }
        //         },
        //         piiLoggingEnabled: false,
        //         logLevel: LogLevel.Verbose
        //     }
        // }
    };

    if (!process.env.REACT_APP_DEV) {
        msal.config = config;
        msal.scopes = [msalConfig.REACT_APP_TCMS_CLIENT_ID + '/.default'];
        msal.instance = await PublicClientApplication.createPublicClientApplication(msal.config);

        // Default to using the first account if no account is active on page load
        if (!msal.instance.getActiveAccount() && msal.instance.getAllAccounts().length > 0) {
            // Account selection logic is app dependent. Adjust as needed for different use cases.
            msal.instance.setActiveAccount(msal.instance.getAllAccounts()[0]);
        }

        // // Listen for sign-in event and set active account
        msal.instance.addEventCallback((event) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
                const account = event.payload as AccountInfo;
                msal.instance.setActiveAccount(account);
            }
        });
    }
};
